import { fixPhraseFromBaas } from 'helpers/validators';
import {
	AccountStatementMovement,
	AccountStatementMovementType,
} from 'types/Account';

const FEE_DESCRIPTION = /cobran[cç]a de tarifa/i;

export const descriptionMatchers = (movement: AccountStatementMovement) => [
	//TODO: add matchers for fee when its available
	{
		matcher:
			movement.movement_type === AccountStatementMovementType.ENTRYCREDIT,
		description: 'Crédito em conta',
	},
	{
		matcher:
			movement.movement_type === AccountStatementMovementType.ENTRYDEBIT,
		description: 'Débito em conta',
	},
	{
		matcher:
			movement.movement_type ===
			AccountStatementMovementType.TEDTRANSFEROUT,
		description: 'Transferência TED',
	},
	{
		matcher:
			movement.movement_type ===
			AccountStatementMovementType.TEDTRANSFERIN,
		description: 'Recebimento TED',
	},
	{
		matcher:
			movement.movement_type ===
			AccountStatementMovementType.PIXREVERSALIN,
		description: 'Estorno PIX',
	},
	{
		matcher:
			movement.movement_type ===
			AccountStatementMovementType.PIXREVERSALOUT,
		description: 'Estorno PIX',
	},
	{
		matcher:
			movement.movement_type ===
			AccountStatementMovementType.TEDREVERSALIN,
		description: 'Estorno',
	},
	{
		matcher:
			movement.movement_type ===
			AccountStatementMovementType.TEDREVERSALOUT,
		description: 'Estorno',
	},
	{
		matcher:
			movement.movement_type ===
			AccountStatementMovementType.PIXPAYMENTOUT,
		description: 'Transferência Pix',
	},
	{
		matcher:
			movement.movement_type ===
			AccountStatementMovementType.TEFTRANSFEROUT,
		description: 'Cobrança de Tarifa',
	},
	{
		matcher:
			movement.movement_type ===
			AccountStatementMovementType.TEFTRANSFERIN,
		description: 'Recebimento TEF',
	},
	{
		matcher:
			movement.movement_type ===
			AccountStatementMovementType.PIXPAYMENTIN,
		description: 'Recebimento Pix',
	},
	{
		matcher:
			movement.movement_type === AccountStatementMovementType.BILLPAYMENT,
		description: 'Pagamento de boleto',
	},
	{
		matcher:
			movement.movement_type === AccountStatementMovementType.CHARGEIN,
		description: 'Recebimento de boleto',
	},
];

export const getStatementDescriptionMatcher = (
	movement: AccountStatementMovement,
) => [
	{
		matcher:
			movement.balance_type === 'DEBIT' &&
			movement.additional_information?.name_credit,
		description: `Enviado para ${
			movement?.additional_information?.name_credit || ''
		}`,
	},
	{
		matcher:
			movement.balance_type === 'CREDIT' &&
			movement.additional_information?.name_debit,
		description: `Recebido de ${movement?.additional_information?.name_debit} || '`,
	},
	{
		matcher: true,
		description: '-',
	},
];

export const getStatementMovementType = (
	movement: AccountStatementMovement,
): string => {
	const match = descriptionMatchers(movement).find(
		matcher => matcher.matcher,
	);
	return match ? match.description : '-';
};

const nameFromDescription = (description: string): string | undefined => {
	const normalized = fixPhraseFromBaas(description).trim();
	const sent = normalized.match(/^Enviado para\s+([^\n|]+)/i);
	const received = normalized.match(/^Recebido de\s+([^\n|]+)/i);
	const debtor = normalized.match(/Sacado:\s*(.+)$/i);
	const name = (sent?.[1] ?? received?.[1] ?? debtor?.[1])?.trim();
	if (!name || name.toLowerCase() === 'undefined') return undefined;
	return name;
};

export const getStatementBeneficiary = (
	movement: AccountStatementMovement,
): string => {
	const description = movement.description ?? '';
	if (FEE_DESCRIPTION.test(description)) return '-';

	const counterparty =
		movement.balance_type === 'DEBIT'
			? movement.additional_information?.name_credit
			: movement.additional_information?.name_debit;
	const name = counterparty?.trim();
	if (name && name.toLowerCase() !== 'undefined') return name;

	return nameFromDescription(description) ?? '-';
};

export const getStatementDescription = (
	movement: AccountStatementMovement,
): string => {
	const value = movement.description?.trim();
	if (!value) return '-';
	return fixPhraseFromBaas(value);
};
